import tooltip from '@/config/tooltip';
import clickOutside from '@/config/click-outside';

export default {
    init() {
        tooltip.init();
        clickOutside.init();
    },
};
